import { cn } from "../../utils/classnames.js";
import { NavigationMenuPositioner } from "../atoms/navigation-menu.js";
import { navigationMenuTriggerStyle } from "./navigation-menu-styles.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from "lucide-react";
import { NavigationMenu } from "@base-ui/react/navigation-menu";
//#region src/components/molecules/navigation-menu.tsx
const NavigationMenu$1 = ({ className, children, viewport = true, align = "start", ...props }) => {
	return /* @__PURE__ */ jsxs(NavigationMenu.Root, {
		"data-slot": "navigation-menu",
		"data-viewport": viewport,
		className: cn("group/navigation-menu relative flex h-full max-w-max flex-1 items-center justify-center", className),
		...props,
		children: [children, viewport && /* @__PURE__ */ jsx(NavigationMenuPositioner, { align })]
	});
};
const NavigationMenuTrigger = ({ className, children, ...props }) => {
	return /* @__PURE__ */ jsxs(NavigationMenu.Trigger, {
		"data-slot": "navigation-menu-trigger",
		className: cn(navigationMenuTriggerStyle(), "group", className),
		...props,
		children: [
			children,
			" ",
			/* @__PURE__ */ jsx(ChevronDownIcon, {
				className: cn(`
          ml-1 size-3 relative top-px transition duration-200
          group-data-open:rotate-180
          group-data-popup-open:rotate-180
        `),
				"aria-hidden": "true"
			})
		]
	});
};
//#endregion
export { NavigationMenu$1 as NavigationMenu, NavigationMenuTrigger };

//# sourceMappingURL=navigation-menu.js.map